/**
 * Game events.
 */
class C_GameEvent
{
    constructor()
    {
        this.SPLASH_CLOSED = "SPLASH_CLOSED";
        this.NAVIGATE = "NAVIGATE";
        this.SOCKET_CONNECTED = "SOCKET_CONNECTED";
        this.BALANCE_UPDATE = "BALANCE_UPDATE";
        this.PLAYER_HIT = "PLAYER_HIT";
        this.PLAY_COINS_ANIM = "PLAY_COINS_ANIM";
        this.PLAY_FLARE_KILL_ANIM = "PLAY_FLARE_KILL_ANIM";
        this.SHOW_GAME_OVER = "SHOW_GAME_OVER";
        this.BOT_JOINED = "BOT_JOINED";
        this.BOT_EXITED = "BOT_EXITED";
        this.BOT_BALANCE_UPDATE = "BOT_BALANCE_UPDATE";
        this.RESCUE_POD_GOO_CLEAN = "RESCUE_POD_GOO_CLEAN";
        this.FLIER_KILL = "FLIER_KILL";

        this.POPUP_CLOSED = "POPUP_CLOSED";
    }
}

export default (new C_GameEvent);